<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Créer une nouvelle consigne</strong>
          </div>
          <b-form>
            <b-form-group label="Code blocage" label-for="codeBlocage">
              <b-form-input
                id="codeBlocage"
                type="text"
                autocomplete="name"
                :class="{hasError: errors.codeBlocage !== ''}"
                v-model="codeBlocage"
              />
              <span class="field-error">{{ errors.codeBlocage }}</span>
            </b-form-group>
            <b-form-group label="Libellé blocage" label-for="libelleBlocage">
              <b-form-input
                id="libelleBlocage"
                type="text"
                autocomplete="name"
                v-model="libelleBlocage" />
            </b-form-group>
            <b-form-group label="Aide" label-for="aide">
              <b-form-textarea
                id="aide"
                type="text"
                :class="{hasError: errors.aide !== ''}"
                rows="3"
                max-rows="6"
                v-model="aide">
              </b-form-textarea>
            </b-form-group>
            <div class="mt-5" slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"/> Liste des consignes
              </b-button>
              <b-button type="button" @click="edit" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"/> Enregistrer
              </b-button>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../../utils/auth";

  export default {
    name: "Edit",
    data() {
      return {
        libelleBlocage: "",
        codeBlocage: "",
        aide: "",
        errors: {
          codeBlocage: "",
          aide: "",
        },
      }
    },
    mounted() {
      this.id = this.$route.params.id;
      this.getConsigneBlocage();
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
    },
    methods: {
      getConsigneBlocage() {
        this.$store.commit('IS_LOADING', true);
        this.$axios
          .get('/espaceGestion/consignes-blocages/' + this.id)
          .then(response => {
            this.$store.commit('IS_LOADING', false);
            this.libelleBlocage = response.data.data.libelle_blocage;
            this.codeBlocage = response.data.data.code_blocage;
            this.aide = response.data.data.aide;
          })
          .catch(() => {
            this.handleError();
          });
      },
      edit() {
        if (this.validateData()) {
          this.$store.commit("IS_LOADING", true);
          let dataPost = {};
          dataPost.libelleBlocage = this.libelleBlocage;
          dataPost.codeBlocage = this.codeBlocage;
          dataPost.aide = this.aide;
          this.$axios
            .put("/espaceGestion/consignes-blocages/" + this.id, dataPost)
            .then(() => {
              this.$store.commit("IS_LOADING", false);
              this.$swal({
                position: "top",
                type: "success",
                title: "Modification avec succès",
                text: "La consigne a été bien modifiée ",
                showConfirmButton: false,
                timer: 5000
              });
              this.returnBack();
            })
            .catch(() => {
              this.$store.commit("IS_LOADING", false);
              this.handleError(this);
            });
        }
      },
      returnBack() {
        this.$router.push({path: "/espace-gestion/consignes-blocage/list"});
      },
      validateData() {
        this.clearErrors()
        let valid = true;

        if (this.codeBlocage === null) {
          this.errors.codeBlocage = "Le code blocage est obligatoire";
          valid = false;
        }

        return valid;
      },
      clearErrors() {
        this.errors.codeBlocage = "";
        this.errors.aide = "";
        this.errors.date_fin = "";
      },
      handleError() {
        this.$swal({
          position: 'top',
          type: 'error',
          title: 'Attention !!',
          text: 'Un problème est survenu, merci de contacter l\'administrateur',
          showConfirmButton: false,
          timer: 5000,
        });
      }
    }
  }
</script>
